// Query for tcounter_terrorism_records (Tab 1 - Danh sách khủng bố)
export const GET_COUNTER_TERRORISM_RECORDS_QUERY = `
  query GetCounterTerrorismRecords($input: TCounterTerrorismRecordsWhereInput!, $skip: Float, $take: Float) {
    getCounterTerrorismRecords(where: $input, skip: $skip, take: $take) {
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemsPerPage
        totalItems
        totalPages
      }
      items {
        id
        organizationName
        fullName
        nickname
        bod
        gender
        nationality
        hometown
        address
        occupation
        createId
        createDate
        modifyId
        modifyDate
        tcreateUser {
          fullName
        }
        tmodifyUser {
          fullName
        }
      }
    }
  }
`;

// Query for tcounter_terrorism_faft (Tab 2 - Danh sách FATF)
export const GET_COUNTER_TERRORISM_FAFT_QUERY = `
  query GetCounterTerrorismFaft($input: TCounterTerrorismFaftWhereInput!, $skip: Float, $take: Float) {
    getCounterTerrorismFaft(where: $input, skip: $skip, take: $take) {
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemsPerPage
        totalItems
        totalPages
      }
      items {
        id
        versionNum
        firstName
        secondName
        thirdName
        unListType
        referenceNumber
        listedOn
        nameOriginalScript
        titles
        designations
        nationalities
        listTypes
        lastDayUpdated
        aliasName
        address
        type
        createId
        createDate
        modifyId
        modifyDate
        tcreateUser {
          fullName
        }
        tmodifyUser {
          fullName
        }
      }
    }
  }
`;

// Query for tcounter_terrorism_peps (Tab 3 - Danh sách PEPS)
export const GET_COUNTER_TERRORISM_PEPS_QUERY = `
  query GetCounterTerrorismPeps($input: TCounterTerrorismPepsWhereInput!, $skip: Float, $take: Float) {
    getCounterTerrorismPeps(where: $input, skip: $skip, take: $take) {
      pageInfo {
        currentPage
        hasNextPage
        hasPreviousPage
        itemsPerPage
        totalItems
        totalPages
      }
      items {
        id
        eventDate
        country
        personName
        eventDescription
        createId
        createDate
        modifyId
        modifyDate
        tcreateUser {
          fullName
        }
        tmodifyUser {
          fullName
        }
      }
    }
  }
`;
